// src/components/NavNew.jsx
import React, { useEffect } from "react";
import logo from "../assets/images/Logo_2.png";
import usePrivyLogin from "../hooks/usePrivyLogin";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Dropdown, Space } from "antd";
import { DownOutlined } from '@ant-design/icons';

const NavNew = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const { ready, authenticated, user, handleLogin, logout } = usePrivyLogin();

  const handleLogout = () => {
    logout();
    if (location.pathname !== '/home') {
      navigate('/home');
    }
  };

  const items = [
    {
      key: "1",
      label: (
        <div
          className="cursor-pointer hover:text-primary-500 py-2 px-4"
          onClick={() => navigate("/profile")}
        >
          {t("View Profile")}
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <div
          onClick={handleLogout}
          className="cursor-pointer hover:text-primary-500 py-2 px-4"
        >
          {t("Log Out")}
        </div>
      ),
    },
  ];

  return (
    <div className="flex justify-between items-center h-[80px] px-6">
      <img
        src={logo}
        alt="logo"
        className="h-[40px] w-auto cursor-pointer transition-transform hover:scale-105"
        onClick={() => navigate("/home")}
      />
      {ready && authenticated ? (
        <div className="flex items-center">
          <Dropdown
            menu={{ items }}
            placement="bottomRight"
            overlayClassName="bg-white rounded-lg shadow-lg"
          >
            <button className="flex items-center bg-gradient-to-r from-primary-400 to-primary-600 text-[#000] px-8 py-5 rounded-[14px] hover:opacity-90 transition-opacity border border-[#191A23]">
              <span className="text-sm font-medium mr-2">
                {user?.wallet?.address ? user.wallet.address : t("Log In")}
              </span>
              <DownOutlined className="text-sm" />
            </button>
          </Dropdown>
        </div>
      ) : (
        <button
          onClick={handleLogin}
          className="flex items-center bg-gradient-to-r from-primary-400 to-primary-600 text-[#000] px-8 py-3 rounded-[14px] hover:opacity-90 transition-opacity shadow-md border border-[#191A23]"
        >
          <span className="text-sm font-medium">
            {t("Log In")}
          </span>
        </button>
      )}
    </div>
  );
};

export default NavNew;